import styled from 'styled-components';
import { CommonDetails } from '../common-styles.styles';
import Image from '@stencil/common-image';

export const Details = styled(CommonDetails)``;

export const Container = styled.div`
  padding-bottom: 20px;
  ${props => props.theme.dF};
`;

export const ImageWrap = styled.div`
  width: 40%;
`;

export const ContentWrap = styled.div`
  width: 60%;
  ${props => props.theme.flexCol};
  line-height: 1.3;
`;

export const Rating = styled.div`
  ${props => props.theme.dF};
`;

export const Location = styled.div`
  ${props => props.theme.dF};
  ${props => props.theme.alignItemsCenter};
`;

export const Price = styled.div`
  color: #000000;
  ${props => props.theme.dF};
  ${props => props.theme.justifyBetween};
  font-size: ${props => props.theme.font.custom(13)};
  padding-top: ${props => props.theme.spacing.custom(5)};
  font-size: ${props => props.theme.font.custom(14)};
`;

export const PriceValue = styled.div`
  ${props => props.theme.dF};
`;

export const RatingNum = styled.div`
  border: 1px solid #b3b3b3;
  border-radius: 10px;
  font-size: ${props => props.theme.font.custom(13)};
  line-height: 1;
  padding: ${props => props.theme.spacing.custom(3)} ${props => props.theme.spacing.custom(5)};
`;

export const Adress = styled.div`
  font-size: ${props => props.theme.font.custom(12)};
  ${props => props.theme.flexCol};
  padding-left: ${props => props.theme.spacing.custom(5)};
`;

export const ListItemImg = styled(Image)`
  width: 90% !important;
  height: 70px !important;
`;

export const AlternateWrap = styled.div`
  width: 100%;
  background-color: #3e4a71;
  padding: ${props => props.theme.spacing.custom(5)};
  margin-top: ${props => props.theme.spacing.small};
  margin-bottom: ${props => props.theme.spacing.small};
`;

export const Name = styled.div`
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: ${props => props.theme.font.custom(14)};
  color: #000000;
`;

export const AttractionInfo = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Header = styled.div`
  padding-bottom: 10px;
  color: #000000;
  line-height: 1.5;
  font-size: 16.38px;
  font-weight: bold;
  font-style: normal;
`;

export const FooterWrap = styled.div`
  padding-bottom: 10px;
  display: flex;
  text-align: right;
  color: #2c67b3;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.5;
  padding: 2px 8px !important;
  justify-content: flex-end;
`;

export const Footer = styled.div`
  background-color: #d8d8d8;
  padding: 3px 5px;
  border-radius: 3px !important;
  text-transform: lowercase;
`;
